// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card[data-v-0373e554]{border-radius:10px}.v-stepper[data-v-0373e554]{background:unset!important;box-shadow:unset}.v-stepper .v-stepper__label[data-v-0373e554]{text-align:center!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
